import { RefreshFilterState } from './refresh.types';

// 0 = All option
export const getDefaultRefreshFilter = (): RefreshFilterState => ({
  refresh: 0,
});
export const defaultRefreshFilter = getDefaultRefreshFilter();
